import { alertError, alertSuccess } from "../../utils/feedback";
import axiosInstance from "../../axios/index";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import {
  REMOVE_ORGANIZATION_PROFILE,
  RESET_STATE,
  SELECT_ORGANIZATION_PROFILE,
  SET_INFINITE_ORGANIZATIONS,
  SET_LIST_OF_STEPS,
  SET_MANAGED_ORGANIZATIONS,
  SET_ORGANIZATION_ID,
  SET_ORGANIZATION_METRICS_BY_ID,
  SET_ORGANIZATION_PROFILES,
  SET_QUESTION_BY_ID,
  SET_QUESTIONS_LIST_BY_STEP_ID,
  SET_RISK_PROFILE,
  SET_SEARCHED_MANAGED_ORGANIZATIONS,
  SET_SEARCHED_ORGANIZATIONS,
  UPDATE_ORGANIZATION_PROFILE,
  GET_ORGA_DESCRIPTION,
  GET_XML_DATA,
} from "../types/organizationProfileType";
import { fetchAllUsers } from "./usersManagementActionCreators";
// import { fetchProfileNames } from "./profileNamesActionCreators";
// import { fetchAllNotifications } from "./notificationsActionCreator";
// import { Sleigh } from "tabler-icons-react";
// import { useSelector } from "react-redux";
// import error from "eslint-plugin-react/lib/util/error";
import { automaticSignOut } from "./userActionCreators";

export const setOrganizationId = (id) => ({
  type: SET_ORGANIZATION_ID,
  payload: id,
});

export const setOrgaProfile = (
  orga,
  // webApp,
  // tabsCompleted,
  // completedQuizzes,
  // completedThreatQuizzes,
  orgaUser
  // completedThreatQuizzesNumber
) => ({
  type: SELECT_ORGANIZATION_PROFILE,
  payload: {
    orga: orga,
    // webApp: webApp,
    // tabsCompleted: tabsCompleted,
    // completedQuizzes: completedQuizzes,
    // completedThreatQuizzes: completedThreatQuizzes,
    orgaUser: orgaUser,
    // completedThreatQuizzesNumber: completedThreatQuizzesNumber,
  },
});
export const setRiskProfileReport = (
  embedToken,
  embedUrl,
  reportId,
  reportName,
  filteredPages,
  startPage
) => ({
  type: SET_RISK_PROFILE,
  payload: {
    embedToken: embedToken,
    embedUrl: embedUrl,
    reportId: reportId,
    reportName: reportName,
    filteredPages: filteredPages,
    startPage: startPage,
  },
});
export const setOrganizationMetricsById = (orgaMetrics) => ({
  type: SET_ORGANIZATION_METRICS_BY_ID,
  payload: orgaMetrics,
});

export const updateOrganizationProfile = (id, data) => ({
  type: UPDATE_ORGANIZATION_PROFILE,
  payload: { id: id, data },
});

export const setOrganizationProfiles = (profiles, totalPages) => ({
  type: SET_ORGANIZATION_PROFILES,
  payload: { profiles, totalPages },
});

export const setInfiniteOrganizations = (profiles, totalPages) => ({
  type: SET_INFINITE_ORGANIZATIONS,
  payload: { profiles, totalPages },
});

export const setSearchedOrganizations = (profiles, totalPages) => ({
  type: SET_SEARCHED_ORGANIZATIONS,
  payload: { profiles, totalPages },
});

export const setManagedOrganizations = (profiles, totalPages) => ({
  type: SET_MANAGED_ORGANIZATIONS,
  payload: { profiles, totalPages },
});

export const setSearchedManagedOrganizations = (profiles, totalPages) => ({
  type: SET_SEARCHED_MANAGED_ORGANIZATIONS,
  payload: { profiles, totalPages },
});

export const removeOrganization = (id) => ({
  type: REMOVE_ORGANIZATION_PROFILE,
  payload: id,
});

export const resetState = () => ({
  type: RESET_STATE,
});

export const setListOfSteps = (steps) => ({
  type: SET_LIST_OF_STEPS,
  payload: steps,
});

export const setQuestionsListByStepId = (questions) => ({
  type: SET_QUESTIONS_LIST_BY_STEP_ID,
  payload: questions,
});

export const setQuestionById = (question) => ({
  type: SET_QUESTION_BY_ID,
  payload: question,
});

export const getOrgadescription = (description) => ({
  type: GET_ORGA_DESCRIPTION,
  payload: description,
});

export const getXmlData = (xmlData) => ({
  type: GET_XML_DATA,
  payload: xmlData,
});

export const updateXmlData = (data, orga_id) => {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));
    try {
      const res = await axiosInstance.post(
        `https://ai.cytailor.io/test/get_update_xml`,
        {
          organization_id: String(orga_id),
          action: "update",
          update_content: data,
        }
      );

      dispatch(requestSucceeded());
      // alertSuccess({
      //   message: "XML data updated successfully!",
      //   message_fr: "Données XML mises à jour avec succès!",
      // });
      return res.data;
    } catch (error) {
      const errData = error?.response?.data;
      dispatch(requestSucceeded());
      // Propagate server error payload so callers can handle field-level errors
      throw errData || error;
    }
  };
};

export const apiXmlData = (orga_id) => {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));
    try {
      const res = await axiosInstance.post(
        `https://ai.cytailor.io/test/get_update_xml`,
        { organization_id: String(orga_id), action: "get" }
      );
      dispatch(getXmlData(res.data));
      // console.log("apiXmlData : ", res.data);
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const launchTeaserReportAndSave = (data) => {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));
    try {
      const res = await axiosInstance.post(
        `/scoring/generate_risk_profile`,
        data
      );
      dispatch(requestSucceeded());
      if (res) {
        alertSuccess(res.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestCreatingOrganizationProfile = (
  data,
  history,
  t,
  accountType
) => {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));
    const token = localStorage.getItem("token");
    const role = JSON.parse(localStorage.getItem("user"))?.role;
    const storedUser = localStorage.getItem("user");
    const user = JSON.parse(storedUser);
    try {
      // const res = token
      //   ? await axiosInstance.post(`/model/profiles`, data)
      //   : await axiosInstance.post(`/model/profiles_off`, data);

      const res = await axiosInstance.post(`/model/profiles`, data);

      dispatch(requestSucceeded());
      localStorage.setItem("orgaId", res.data.id);
      if (token) {
        user.org_name = res?.data?.name_A;
        user.organization_id = res?.data?.id;
        if (role === "enterprise_admin" || role === "cytailor_admin") {
          user.managed_organizations = [
            ...user.managed_organizations,
            { orga_name: res?.data?.name_A, orga_id: res?.data?.id },
          ];
        }
        if (accountType === "free") {
          user.entreprise = res?.data?.name_A;
        }
        localStorage.setItem("user", JSON.stringify(user));
      }
      if (token) {
        // if (role === "cytailor_admin") {
        //
        // const res2 = await axiosInstance.get(`/model/profiles/${res.data.id}`);
        // const items = res2?.data?.profile_data;

        // const res2 = await axiosInstance.get(`/model/profiles/${res.data.id}`);
        // const items = res2?.data?.profile_data;
        // history.push({
        //   pathname: "/edit-profile-organization",
        //   state: {
        //     step: [1],
        //     // jsonData: JSON.parse(items?.organization_data),
        //     profileId: res.data.id,
        //   },
        // });

        setTimeout(() => {
          // history.push("/enterprise");
        }, 1000);
        dispatch(getOrganizatonProfiles(1, "", ""));
        // } else {
        //   history.push("/");
        // }
      } else {
        history.push("/");
      }
      if (res) {
        alertSuccess({
          message: "Profile added successfully!",
          message_fr: "Profil ajouté avec succès!",
        });
      }
    } catch (error) {
      if (error?.response?.status === 400) {
        dispatch(requestFailed(error?.response?.data));
      } else {
        dispatch(requestFailed(error?.response?.data));
      }
    }
  };
};

export async function requestLanchTeaserReport(data) {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));
    const token = localStorage.getItem("token");
    const role = JSON.parse(localStorage.getItem("user"))?.role;
    const storedUser = localStorage.getItem("user");
    const user = JSON.parse(storedUser);
    try {
      const res = await axiosInstance.post(
        `/scoring/generate_risk_profile`,
        data
      );
      dispatch(requestSucceeded());
      console.log("requestLanchTeaserReport : ", res);
    } catch (error) {
      if (error?.response?.status === 400) {
        dispatch(requestFailed(error?.response?.data));
      } else {
        dispatch(requestFailed(error?.response?.data));
      }
    }
  };
}

export const getOrganizationProfileById = (id, profileDetails) => {
  return async (dispatch) => {
    if (profileDetails) {
      dispatch(requestStarted("orga"));
    }
    try {
      const res = await axiosInstance.get(`/model/profiles/${id}`);
      const items = res?.data?.profile_data;
      const orgaUser = res?.data?.user_data;
      // const webApp =
      //   JSON.parse(items?.organization_data)?.WebApp_status_F === null
      //     ? true
      //     : false;
      // const tabsCompleted = items?.tabs_completed;
      // const completedQuizzes = items?.completed_quizzes;
      // const pendingQuizzes = items?.pending_quizzes;
      // const completedThreatQuizzes = items?.completed_threat_quizzes;
      // // const completedThreatQuizzesNumber = items?.completed_threat_quizzes_nb;
      // const completedThreatQuizzesNumber = items?.completed_quizzes_nb;
      // localStorage.setItem("pending_quizzes", pendingQuizzes);
      dispatch(
        setOrgaProfile(
          items,
          // webApp,
          // tabsCompleted,
          // completedQuizzes,
          // completedThreatQuizzes,
          orgaUser
          // completedThreatQuizzesNumber
        )
      );
      if (profileDetails) {
        dispatch(requestSucceeded());
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const getOrganizatonProfiles = (
  page,
  searchText,
  status,
  infinite,
  forUsers
) => {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));
    try {
      const res = await axiosInstance.get(
        `/model/profiles?page=${page}&search${
          searchText ? "=" + searchText : ""
        }&status${status !== "" ? "=" + status : ""}`
      );
      const items = res?.data;
      dispatch(requestSucceeded());
      if (infinite) {
        if ((searchText || status !== "") && page === 1) {
          dispatch(
            setSearchedOrganizations(items?.profiles, items?.total_pages)
          );
        } else {
          dispatch(
            setInfiniteOrganizations(items?.profiles, items?.total_pages)
          );
        }
      } else {
        dispatch(setOrganizationProfiles(items?.profiles, items?.total_pages));
      }
      if (!infinite) {
        dispatch(fetchAllUsers(1, "", "all", null));
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const getManagedOrganizatonProfiles = (page, searchText) => {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));
    try {
      const res = await axiosInstance.get(
        `/model/managed_organizations?page=${page}&search${
          searchText ? "=" + searchText : ""
        }`
      );
      const items = res?.data;
      if (searchText && page === 1) {
        dispatch(
          setSearchedManagedOrganizations(items?.profiles, items?.total_pages)
        );
      } else {
        dispatch(setManagedOrganizations(items?.profiles, items?.total_pages));
      }

      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const getOrganizatonMetricsById = (id) => {
  return async (dispatch) => {
    const normalizedId =
      id !== undefined && id !== null ? String(id).trim() : "";
    if (
      !normalizedId ||
      normalizedId.toLowerCase() === "null" ||
      normalizedId.toLowerCase() === "undefined"
    ) {
      return;
    }

    dispatch(requestStarted("orga"));
    try {
      const res = await axiosInstance.get(`/model/get_profile/${normalizedId}`);
      const items = res?.data;
      dispatch(setOrganizationMetricsById(items?.profiles));
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const getRiskProfile = (orgaId, accountType, language) => {
  const lang = language.indexOf("fr") !== -1 ? "fr" : "en";
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.get(
              `/scoring/view_risk_profile?orga_id=${orgaId}&language=${lang}`
            )
          : await axiosInstance.get(
              `/scoring/view_risk_profile?language=${lang}`
            );

      if (accountType !== "free") {
        localStorage.setItem("orgaId", orgaId);
      }
      const embedToken = res?.data?.embed_token;
      const embedUrl = res?.data?.embed_url;
      const reportId = res?.data?.report_id;
      const reportName = res?.data?.report_name;
      const filteredPages = res?.data?.filtered_pages;
      const startPage = res?.data?.start_page;
      localStorage.setItem("reportName", reportName);
      dispatch(
        setRiskProfileReport(
          embedToken,
          embedUrl,
          reportId,
          reportName,
          filteredPages,
          startPage
        )
      );
      if (accountType !== "free") {
        dispatch(getOrganizatonMetricsById(orgaId));
      }
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      throw error;
    }
  };
};
export const exportRiskProfile = (orgaId, accountType, language) => {
  const lang = language.indexOf("fr") !== -1 ? "fr" : "en";
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const response =
        accountType === "enterprise"
          ? await axiosInstance.get(
              `/scoring/export_risk_profile?orga_id=${orgaId}&language=${lang}&download=false`
            )
          : await axiosInstance.get(
              `/scoring/export_risk_profile?language=${lang}&download=false`
            );
      if (response) {
        alertSuccess(response?.data);
      }
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
export const downloadRiskReport = (
  orgaId,
  language,
  download,
  export_id,
  reportName
) => {
  const lang = language.indexOf("fr") !== -1 ? "fr" : "en";
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const response = await axiosInstance.get(
        `/scoring/export_risk_profile?orga_id=${orgaId}&language=${lang}&download=${download}&export_id=${export_id}`,
        { responseType: "blob" }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${reportName}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

// const checkTaskStatusInBackground = async (taskId, orgaId, dispatch,isAuth) => {
//   try {
//     let taskStatus = "pending";
//     let counter = 0;
//     const maxAttempts = 3;
//
//     while (taskStatus === "pending" && counter < maxAttempts && taskId && isAuth) {
//       console.log("isAuth",isAuth)
//       await new Promise((resolve) => setTimeout(resolve, 7000));
//       const response = await axiosInstance.get(`/model/task_status/${taskId}?orga_id=${orgaId}`);
//       taskStatus = response.data.task_status;
//       counter++;
//
//       if (taskStatus === "success") {
//         dispatch(fetchAllNotifications());
//         return;
//       }
//     }
//
//     } catch (error) {
//       console.error("Error caught:", error.message || error);
//       dispatch(requestFailed(error?.response?.data || error.message));
//     }
//   };

export const requestUpdatingOrganizationProfile = (
  id,
  data,
  history,
  isAuth
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.put(`/model/profiles/${id}`, data);
      const storedUser = localStorage.getItem("user");
      const accountType = JSON.parse(storedUser).account_type;
      // checkTaskStatusInBackground(res.data.backgroun_task_id, id, dispatch,isAuth);
      dispatch(requestSucceeded());
      dispatch(updateOrganizationProfile(id, data));
      history.push("/profile");
      dispatch(getOrganizationProfileById(id));
      if (accountType === "enterprise") {
        dispatch(getOrganizatonProfiles(1, "", ""));
      }

      if (res) {
        alertSuccess({
          message: "Organization Profile updated successfully!",
          message_fr: "Profile d'organisation mis à jour avec succès!",
        });
      }
    } catch (error) {
      if (error?.response?.status === 400) {
        dispatch(requestFailed(error?.response?.data));
      } else {
        dispatch(requestFailed(error?.response?.data));
      }
    }
  };
};

export const requestDeletingOrganization = (page, searchText, status, id) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.delete(`model/profiles/${id}`);
      dispatch(requestSucceeded(res.data));
      const storedUser = localStorage.getItem("user");
      const user = JSON.parse(storedUser);

      user.managed_organizations = user.managed_organizations.filter(
        (el) => el.orga_id !== id
      );

      localStorage.setItem("user", JSON.stringify(user));
      if (res) {
        alertSuccess(res.data);
      }
      // dispatch(fetchProfileNames());
      dispatch(removeOrganization(id));
      dispatch(getOrganizatonProfiles(page, searchText, status));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export async function checkDomainName(name) {
  const language = localStorage.getItem("i18nextLng");
  try {
    const url = "/model/validate_domain";
    const res = await axiosInstance.post(url, { name_A: name });
    return {
      valid: res.data.valid,
      message: language === "fr" ? res?.data?.message_fr : res?.data?.message,
    };
  } catch (error) {
    console.log(error);
  }
}

export function getListOfStep(ogrga_id) {
  return async (dispatch) => {
    try {
      const url = `/model/fetch_all_orga_steps/${ogrga_id}`;
      const res = await axiosInstance.get(url);
      // Dispatch the action to save steps in the Redux store
      dispatch(setListOfSteps(res.data.steps));
    } catch (error) {
      console.error("Error fetching steps:", error);
      dispatch(requestFailed(error?.response?.data));
    }
  };
}

export function getQuestionByStepId(stepId, orga_id) {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));
    try {
      const url = `/model/fetch_questions_by_step/${stepId}/${orga_id}`;
      const res = await axiosInstance.get(url);
      dispatch(setQuestionsListByStepId(res.data.questions));
      dispatch(requestSucceeded());
    } catch (error) {
      console.error("Error fetching questions:", error);
      dispatch(requestFailed(error?.response?.data));
    }
  };
}

export const errorMessage = (err) => {
  const language = localStorage.getItem("i18nextLng");
  let errorM;
  console.log("errorMessage : ", err);
  if (language === "en") {
    errorM =
      err?.message || (err?.message === null ? undefined : "Request failed");
  } else if (language === "fr") {
    errorM =
      err?.message_fr ||
      (err?.message_fr === null ? undefined : "Request failed");
  }
  if (typeof err == "string") errorM = err;

  if (err.error_ === "token expired") {
    return automaticSignOut();
  } else {
    alertError(errorM);
  }
};

export async function getAllQuestion(stepId, orga_id) {
  // return async (dispatch) => {
  try {
    const url = `/model/edit_all_questions_by_step/${stepId}/${orga_id}`;
    const res = await axiosInstance.get(url);
    return res.data.questions;
    // dispatch(setQuestionsListByStepId(res.data.questions))
  } catch (error) {
    console.error("Error fetching questions:", error);
    errorMessage(error);
    //  dispatch(requestFailed(error?.response?.data));
  }
  // }
}

export async function getQuestionById(question_identifier, orga_id) {
  // return async (dispatch) => {
  try {
    if (question_identifier && orga_id) {
      const url = `/model/orga_question/${question_identifier}/${orga_id}`;
      const res = await axiosInstance.get(url);
      return res.data?.orga_question;
      // dispatch(setQuestionById(res.data?.orga_question))
    }
  } catch (error) {
    errorMessage(error?.response?.data);
    requestFailed(error?.response?.data);
  }
  // }
}

export async function updateOrgaProfile(data, orga_id) {
  // return async (dispatch) => {
  try {
    const url = `/model/update_orga_profile/${orga_id}`;
    const res = await axiosInstance.put(url, data);
    if (res) {
      // dispatch(requestSucceeded());
      // dispatch(updateOrganizationProfile(orga_id, data));
      return res.status;
    }
  } catch (error) {
    errorMessage(error?.response?.data);

    requestFailed(error?.response?.data);
  }
  // }
}

export function getOrgadescriptionById(orga_id) {
  return async (dispatch) => {
    dispatch(requestStarted("orga"));
    try {
      const url = `/scoring/generate_orga_description/${orga_id}`;
      const res = await axiosInstance.get(url);
      await dispatch(getOrgadescription(res?.data?.orga_description));
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
}

export function updateOrgaDescription(orga_id, description) {
  return async (dispatch) => {
    dispatch(requestSucceeded("orga"));
    try {
      const url = `/scoring/generate_orga_description/${orga_id}`;
      const res = await axiosInstance.put(url, {
        orga_description: description,
      });
      dispatch(requestSucceeded());
      alertSuccess(res?.data);
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
}

export function generateOrgaDescription(orga_id) {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const url = `/scoring/generate_orga_description/${orga_id}`;
      const res = await axiosInstance.post(url, { confirm: "true" });
      dispatch(requestSucceeded());
      alertSuccess(res?.data);
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
}

// export const startEvaluation = (orgaId) => {
//   return async (dispatch) => {
//     dispatch(requestStarted());
//     try {
//       const res = await axiosInstance.post("/survey/start_evaluation", {
//         orga_id: orgaId,
//       });
//       dispatch(requestSucceeded());
//       alertSuccess(res.data);
//       return res.data;
//     } catch (error) {
//       dispatch(requestFailed(error?.response?.data));
//     }
//   };
// };

export const startEvaluation = (
  orgaId,
  reportType,
  withValidation = false,
  reportLanguage = "fr"
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const safeReportType =
        reportType === "flash_report" || reportType === "risk_report"
          ? reportType
          : "flash_report";
      const safeReportLanguage = ["fr", "eng", "esp"].includes(reportLanguage)
        ? reportLanguage
        : "fr";

      const payload = {
        orga_id: orgaId,
        report_type: safeReportType,
        report_language: safeReportLanguage,
      };

      if (safeReportType === "risk_report") {
        payload.with_validation = Boolean(withValidation);
      }

      const res = await axiosInstance.post("/survey/start_evaluation", payload);

      dispatch(requestSucceeded());
      alertSuccess(res.data);
      return res.data;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      return null;
    }
  };
};
